module.exports = __webpack_public_path__ + "img/Type_Ice.f516153c.png";